import Settings                                                                   from '../../../pages/site/Settings';
import { getSiteAddressRoute, getSiteFinancialReportRoute, getSiteSettingsRoute } from './factory/setting';
import Report                                                                     from '../../../pages/site/Report';
import Address                                                                    from '../../../pages/site/Address';

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
	{
		path: getSiteSettingsRoute(),
		component: Settings,
		type: 'route',
		loginRequired: true,
	},
	{
		path:          getSiteFinancialReportRoute(),
		component:     Report,
		exact:         true,
		type:          'route',
		loginRequired: true,
	},
	{
		path: getSiteAddressRoute(),
		component: Address,
		type: 'route',
		loginRequired: true,
	},
];

export default routes;
